import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 7, height: 6, viewBox: "0 0 7 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.03367 5.1626C3.80777 5.55387 3.24301 5.55387 3.01711 5.1626L0.983978 1.64111C0.758075 1.24984 1.04045 0.760742 1.49226 0.760742L5.55852 0.760742C6.01033 0.760742 6.29271 1.24984 6.0668 1.64111L4.03367 5.1626Z", fill: "#C4C4C4" }));
const ForwardRef = forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
